var _rect, _path, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaytoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1916,
    viewBox: "0 0 1920 1916",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1916,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M911.004 173.88L899.364 216H896.424L884.904 178.08L873.204 216H870.384L858.924 173.88H861.804L871.884 212.22L883.464 173.88H886.464L897.924 212.46L908.064 173.88H911.004ZM914.827 199.68C914.827 196.32 915.487 193.38 916.807 190.86C918.167 188.34 920.027 186.4 922.387 185.04C924.787 183.68 927.507 183 930.547 183C933.987 183 936.907 183.84 939.307 185.52C941.707 187.2 943.387 189.34 944.347 191.94V183.42H947.047V216H944.347V207.42C943.387 210.06 941.687 212.24 939.247 213.96C936.847 215.64 933.947 216.48 930.547 216.48C927.507 216.48 924.787 215.8 922.387 214.44C920.027 213.04 918.167 211.08 916.807 208.56C915.487 206 914.827 203.04 914.827 199.68ZM944.347 199.68C944.347 196.84 943.747 194.34 942.547 192.18C941.387 189.98 939.787 188.3 937.747 187.14C935.707 185.94 933.427 185.34 930.907 185.34C928.267 185.34 925.947 185.92 923.947 187.08C921.947 188.2 920.387 189.84 919.267 192C918.147 194.16 917.587 196.72 917.587 199.68C917.587 202.64 918.147 205.2 919.267 207.36C920.387 209.52 921.947 211.18 923.947 212.34C925.987 213.5 928.307 214.08 930.907 214.08C933.427 214.08 935.707 213.5 937.747 212.34C939.827 211.14 941.447 209.46 942.607 207.3C943.767 205.1 944.347 202.56 944.347 199.68ZM981.118 183.42L962.158 231.3H959.398L965.458 216L951.778 183.42H954.718L966.958 213L978.358 183.42H981.118ZM1024.96 173.88V176.16H1012.96V216H1010.26V176.16H998.257V173.88H1024.96ZM1044.52 216.48C1041.48 216.48 1038.74 215.8 1036.3 214.44C1033.86 213.08 1031.94 211.14 1030.54 208.62C1029.18 206.06 1028.5 203.08 1028.5 199.68C1028.5 196.32 1029.2 193.38 1030.6 190.86C1032 188.3 1033.92 186.36 1036.36 185.04C1038.84 183.68 1041.6 183 1044.64 183C1047.68 183 1050.42 183.68 1052.86 185.04C1055.3 186.36 1057.2 188.28 1058.56 190.8C1059.96 193.32 1060.66 196.28 1060.66 199.68C1060.66 203.08 1059.96 206.06 1058.56 208.62C1057.16 211.14 1055.22 213.08 1052.74 214.44C1050.3 215.8 1047.56 216.48 1044.52 216.48ZM1044.52 214.08C1046.88 214.08 1049.08 213.56 1051.12 212.52C1053.2 211.44 1054.86 209.82 1056.1 207.66C1057.34 205.5 1057.96 202.84 1057.96 199.68C1057.96 196.56 1057.34 193.92 1056.1 191.76C1054.86 189.6 1053.22 188 1051.18 186.96C1049.14 185.88 1046.94 185.34 1044.58 185.34C1042.22 185.34 1040.02 185.88 1037.98 186.96C1035.98 188 1034.36 189.6 1033.12 191.76C1031.88 193.92 1031.26 196.56 1031.26 199.68C1031.26 202.84 1031.86 205.5 1033.06 207.66C1034.3 209.82 1035.92 211.44 1037.92 212.52C1039.96 213.56 1042.16 214.08 1044.52 214.08Z",
    fill: "#404040"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 260,
    width: 600,
    height: 3,
    fill: "url(#paint0_linear_21_328)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 260,
    width: 600,
    height: 3,
    fill: "white",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_328",
    x1: 660,
    y1: 260,
    x2: 1260,
    y2: 260,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#42C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7737FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaytoBackground);
export default __webpack_public_path__ + "static/media/waytoBackground.125c2542210e33795d13b9eec862476c.svg";
export { ForwardRef as ReactComponent };